module.exports = __webpack_public_path__ + "img/1500520514.20c06746.jpg";